module.exports = __webpack_public_path__ + "static/media/thermometer.000f73d4.svg";